import React from "react";
import {Routes, Route} from "react-router-dom";
import {withCotizarContextProvider, withCotizarContextReady} from "../context/CotizarContext/withCotizarContext";
import {compose} from "recompose";
import Clientes from "../pages/Clientes/Clientes";
import Products from "../pages/Products/Products";
import Quotation from "../pages/Quotation/Quotation";
import "../css/styles.css";
import "../App.css";
import { usePageViewTracker } from "../hooks/analytics/usePageViewTracker";

const QuotationWithContext = compose(
    withCotizarContextProvider,
    withCotizarContextReady
)(Quotation);

export default function ClientesRoutes() {
    usePageViewTracker();
    return (
        <div className={`polko-theme general`}>
                <Routes>
                    <Route path="/" element={<Clientes/>}/>
                    <Route path="/productos" element={<Products/>}/>
                    <Route path="/cotizar/:producto" element={<QuotationWithContext/>}/>
                </Routes>
        </div>

    );
}
